import { render, staticRenderFns } from "./AlunoTurmaGeral.vue?vue&type=template&id=55be1cfb&"
import script from "./AlunoTurmaGeral.vue?vue&type=script&lang=js&"
export * from "./AlunoTurmaGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports